import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage,
});

export default new Vuex.Store({
    state: {
        loggedIn: false,
    },
    mutations: {
        setLoggedIn(state) {
            state.loggedIn = true;
        },
        setLoggedOut(state) {
            state.loggedIn = false;
        },
    },
    actions: {},
    getters: {},
    plugins: [vuexLocal.plugin],
});
